module.exports = __webpack_public_path__ + "static/media/residentcard.22655d69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/user/residentcard.svg
// module id = 620
// module chunks = 1